import { Injectable } from '@angular/core';

import { Router } from '@angular/router';
import { Token } from '../manager/token';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable, BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: "root",
})
export class AgentInboxMappingService {
  TokenCls;
  InboxInventoryId: number;
  InboxInventoryLogId: number;
  getCategoryName: string;

  // Start Idecision Tree pre-analysis
  public preAnalysisQuestionList = new BehaviorSubject([]);
  public postQuestionList = new BehaviorSubject([]);

  public preAnalysisNotes = new BehaviorSubject([]);
  public postNotes = new BehaviorSubject([]);

  public storePreNotes = new BehaviorSubject([]);

  public storeFinalPreQuestionsAnswers = new BehaviorSubject([]);
  public storeFinalPostQuestionsAnswers = new BehaviorSubject([]);

  public backupQuestionList = new BehaviorSubject([]);
  // End Idecision Tree pre-analysis

  is_PreAnalysis: Subject<any> = new Subject<any>();

  constructor(private http: HttpClient, private router: Router) {
    this.TokenCls = new Token(this.router);
  }

  getAgentcategory(clientId): any {
    console.log("addNewLine() service : ");
    return this.http
      .get(environment.ApiUrl + `/api/get-agent-category/${clientId}`)
      .pipe(map((res) => res));
  }

  getAgentQueue(clientId, category): any {
    return this.http
      .get(
        environment.ApiUrl +
        `/api/get-agent-queue/${clientId}?category=${category}`)
      .pipe(map((res) => res));
  }


  getAgentInbox(clientId, queue, subQue): any {
    return this.http
      // .get(
      //   environment.ApiUrl + `/api/get-agent-inbox/${clientId}?Queue=${queue}`)
      // .pipe(map((res) => res));

      .get(
        environment.ApiUrl + `/api/Concluder_Inboxs_Name_Count_Scenario_/Get/${clientId}/${queue}/${subQue}`)
      .pipe(map((res) => res));
  }
  getCimAgentAccount(clientId, queue, inbox): any {
    return this.http
      .get(
        environment.ApiUrl +
        `/api/cim-agent-account/${clientId}?queue=${queue}&inbox=${inbox}`)
      .pipe(map((res) => res));
  }

  GetInboxAllFields(clientId, inventoryid, inventoryLogId, queue_Name, Inbox_Name, WorkType): any {
    return this.http.get(
      environment.ApiUrl + `/api/cim-agent-field/${clientId}/${inventoryid}/${inventoryLogId}?queue=${queue_Name}&inbox=${Inbox_Name}&WorkType=${WorkType}`);
  }

  UpdateInventoryTimeInbox(formobj: any): any {
    console.log('UpdateInventoryTime formobj Inbox : ', formobj)
    return this.http.put(environment.ApiUrl + '/api/cim-agent-time', formobj);
  }

  SaveAllFieldsInbox(formobj): any {
    return this.http.put(environment.ApiUrl + '/api/cim-agent-field', formobj);
  }
  InsertEndTimeOfInboxInventory(formobj): any {
    return this.http.post(environment.ApiUrl + '/api/cim-agent-time', formobj)
  }

  getScenarioQuestions(clientId,scenarioId,inventoryId,categoryName) {
    return this.http.get(environment.ApiUrl + `/api/iDecisionTree-Questions/${clientId}/${scenarioId}/${inventoryId}/${categoryName}`).pipe(map((res) => res));
  }

  SaveiDecisionTreeValues(formobj) {
    console.log("sendddd", formobj);
    return this.http.post(environment.ApiUrl + '/api/Concluder-ScenarioQuestion-Answer', formobj)

  }
  getAgentCategoryQueue(clientId, category): any {
    return this.http.get(environment.ApiUrl + `/api/Concluder-Queue-Scenario-Name-Count/${clientId}?category=${category}`)
      .pipe(map((res) => res));
  }
  // for standard fields data
  getCimAgentScenarioAccount(clientId, queue, inbox,scenarioName): any {
    return this.http
      .get(
        environment.ApiUrl +
        `/api/cim-agent-account/${clientId}?queue=${queue}&inbox=${inbox}&Scenario=${scenarioName}`)
      .pipe(map((res) => res));
  }
  // on agent screen/view button for questions and answers
  getviewScenarioPage(clientId, inventoryId, inventoryLogId,scenarioId,categoryName): any {
    return this.http
      .get(
        environment.ApiUrl +
        `/api/iDecisionTree-QuestionAnswer/${clientId}/${inventoryId}/${inventoryLogId}/${scenarioId}/${categoryName}`)
      .pipe(map((res) => res));
  }


  // on focus event for TFL and AFL (carerul function)
  getcarerulResponse(carerulObj): any {
    return this.http
      .post(
        environment.ApiUrl +
        '/api/ConcluderinboxLimitFuncation',carerulObj)
      .pipe(map((res) => res));
  }

  // api for get multi grid inbox data
  getAgentInboxMultiGridList(clientId, bucket_Name, inbox, scenario): any{
    return this.http.get(environment.ApiUrl + '/api/agent-multiple-grid/client/' + clientId + '/?bucket_Name=' + bucket_Name + '&inbox=' + inbox + '&Scenario=' + scenario);
  }

  // API for submit iAgent multigrid data
  saveiAgentMultiGridFields(clientId, bucket_Name, inbox, scenario,formobj): any{
    return this.http.put(environment.ApiUrl + '/api/agent-multiple-grid/client/' + clientId + '/?bucket_Name=' + bucket_Name + '&inbox=' + inbox + '&Scenario=' + scenario, formobj);
  }

  // For iAGent View page
  getiAgentInboxViewMultiGridList(clientId, inventory_Id,inventory_log_Id, bucket_Name, inbox, scenario): any{
    return this.http.get(environment.ApiUrl + '/api/agent-view-Multigrid/client/' + clientId + '/' + inventory_Id + '/' + inventory_log_Id + '/?bucket_Name=' + bucket_Name + '&inbox=' + inbox + '&Scenario=' + scenario);
  }

  // submit action code
  SaveiDecisionActionCode(formobj) {
    return this.http.post(environment.ApiUrl + '/api/Get_Action_Code', formobj)
  }

  // Get All provider name
  getAllProviderNames(clientId){
    return this.http.get(environment.ApiUrl + '/api/provider/client/' + clientId);
  }

  // Get InventoryTotalTime
  getInventoryTotalTime(clientId,inventoryLogid){
    return this.http.get(environment.ApiUrl + '/api/Get_InventoryTotal_Time/' + clientId + '/'  + inventoryLogid);
  }
}


// for Work_Type
export enum Work_Type {
  ANALYSIS = 'ANALYSIS',
  QUESTIONNAIRE = 'QUESTIONNAIRE',
  INBOX = 'INBOX'
}
